import { StyledMultiFileDropZone } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepContent/component/RightPanel/styled';
import { useUploadAndApproveFile } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepContent/component/RightPanel/component/Review/component/KycActionButton/hook/useUploadAndApproveFile';
import { ACCEPT_FILES_TYPES } from '@dealstack/frontend/shared/components/MultiFileDropZone/MultiFileDropZone';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { useManageKYCController } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/useManageKYCController';
import { useSearchParams } from 'react-router-dom';

interface Props {
	selectedKycId: string | undefined;
	activeInvestorId: string | undefined;
}

export const ReplaceKycFileButton = ({ selectedKycId, activeInvestorId }: Props) => {
	const tMipManage = useTranslationMipManage();
	const [searchParams] = useSearchParams();
	const kycWorkflowId = searchParams.get('kycWorkflowId') ?? undefined;
	const { getKYCDataRequest } = useManageKYCController(activeInvestorId, kycWorkflowId);
	const { uploadFileAndApproveMutation } = useUploadAndApproveFile({
		selectedKycId,
		getKYCDataRequest,
	});

	return (
		<StyledMultiFileDropZone
			primaryText={tMipManage('kyc.review.replace_file')}
			loading={uploadFileAndApproveMutation.isPending}
			minWidth="100%"
			size="STD"
			disabled={false}
			onDropFile={async (file) => {
				const formData = new FormData();
				formData.append('file', file[0]);
				uploadFileAndApproveMutation.mutate({ formData });
			}}
			multiple={false}
			accept={{
				...ACCEPT_FILES_TYPES.imagesAndPdf,
			}}
		/>
	);
};
